import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import { INetworkMessage } from '../models/network.model';
import { IRequest } from '../models/request.model';
import * as firebase from 'firebase';
import { UtilitiesProvider } from './utilities';

@Injectable()
export class NetworkProvider {

  constructor(
    private afDatabase: AngularFireDatabase,
    private afStore: AngularFirestore,
    private utilities: UtilitiesProvider
  ) { }

  getNetworkUser(cUser: string, tUser: string, clientId: string) {
    this.utilities.consoleDecorator('Finding data networking', [cUser, tUser, clientId]);
    return this.afStore
      .collection(clientId)
      .doc('Request')
      .collection(cUser, ref =>
        ref.where('type', '==', 'networkingRequest').where('requested', '==', tUser).limit(1)
      ).valueChanges();
  }

  // getRequestListBy(cUser: string, clientId: string) {
  //   return this.afDatabase.list(`/Clients/${clientId}/UsersNetwork/${cUser}`).valueChanges();
  // }

  /**
   * Crea el registro de solicitud de networking
   *
   * @param cUser usuario que envia la solicitud
   * @param tUser usuario que recibe la solicitud
   * @param clientId
   */
  sendNetworkRequest(cUser: string, tUser: string, clientId: string): any {
    const key = this.afDatabase.createPushId();

    return this.afStore
      .collection(clientId)
      .doc('Request')
      .collection(cUser)
      .doc(key)
      .set({
        id: key,
        type: 'networkingRequest',
        requested: tUser,
        requestor: cUser,
        status: 'sending',
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      })
      .then(() => this.afStore
        .collection(clientId)
        .doc('Request')
        .collection(tUser)
        .doc(key)
        .set({
          id: key,
          type: 'networkingRequest',
          requestor: tUser,
          requested: cUser,
          status: 'pending',
          createdAt: firebase.firestore.FieldValue.serverTimestamp()
        })
      ).then(() => this.transactionRequest(cUser, tUser, clientId));
  }

  /**
   * Genera la transaccion de estadisticas del usuario en netwokring stats
   *
   * @param cUser usuario que envia la solicitud
   * @param tUser usuario que recibe la solicitud
   * @param clientId
   */
  private transactionRequest(cUser: string, tUser: string, clientId: string): any {
    return firebase.database().ref(`/Clients/${clientId}/UserStats/${cUser}/NetworkingRequested`)
      .transaction(count => {
        return count += 1;
      }).then(() =>
        firebase.database().ref(`/Clients/${clientId}/UserStats/${tUser}/NetworkingRequestor`)
          .transaction(count => {
            return count += 1;
          })
      );
  }

  /**
   *
   * @param cUser usuario que envia la solicitud
   * @param tUser usuario que recibe la solicitud
   * @param clientId
   */
  getNetworkMessages(cUser: string, tUser: string, clientId: string) {
    this.utilities.consoleDecorator('get Networking messages', [cUser, tUser]);
    return this.afStore.collection(clientId).doc('networking').collection<INetworkMessage>('messages',
      ref => ref.where('sendedBy', '==', cUser).where('sendedTo', '==', tUser).orderBy('sendedAt', 'desc')
    ).valueChanges().mergeMap(ownList => {
      return this.afStore.collection(clientId).doc('networking').collection<INetworkMessage>('messages',
        ref => ref.where('sendedBy', '==', tUser).where('sendedTo', '==', cUser).orderBy('sendedAt', 'desc')
      ).valueChanges().map(toList => ownList.concat(toList).sort((a, b) => a.sendedAt - b.sendedAt))
    });
  }

  sendNetworkingMessage(cUser: string, tUser: string, clientId: string, message: string) {
    const key = this.afStore.createId();
    return this.afStore.collection(clientId).doc('networking').collection('messages').doc(key).set({
      sendedAt: firebase.firestore.FieldValue.serverTimestamp(),
      sendedBy: cUser,
      sendedTo: tUser,
      body: message,
    }).then(() => this.afStore.collection(clientId).doc('Request').collection(tUser).doc(key).set({
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      id: key,
      status: 'pending',
      type: 'networkingMessage',
      requested: cUser,
      requestor: tUser,
      message: message
    }));
  }

  readNetworkingMessage(clientId: string, userId: string, requestId: string) {
    return this.afStore.collection(clientId).doc('Request').collection(userId).doc(requestId).update({
      updateAt: firebase.firestore.FieldValue.serverTimestamp(),
      status: 'reading'
    });
  }

  stateNetworkUser(request: IRequest, clientId: string, state: 'match' | 'reject') {
    return this.afStore.collection(clientId).doc('Request').collection(request.requestor).doc(request.id)
      .update({ status: state, updateAt: firebase.firestore.FieldValue.serverTimestamp() })
      .then(() => {
        this.afStore.collection(clientId).doc('Request').collection(request.requested).doc(request.id)
          .update({ status: state, updateAt: firebase.firestore.FieldValue.serverTimestamp() })
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/network.ts